import { render, staticRenderFns } from "./checkTab.vue?vue&type=template&id=500aa8aa&scoped=true&"
import script from "./checkTab.vue?vue&type=script&lang=js&"
export * from "./checkTab.vue?vue&type=script&lang=js&"
import style0 from "./checkTab.vue?vue&type=style&index=0&id=500aa8aa&lang=less&scoped=true&"
import style1 from "./checkTab.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500aa8aa",
  null
  
)

export default component.exports